export const customerStatuses = ['Prospect', 'Customer', 'Legacy'] as const;

export type CustomerStatus = (typeof customerStatuses)[number];

export const isCustomerStatus = (status: unknown): status is CustomerStatus =>
  status === 'Prospect' || status === 'Customer' || status === 'Legacy';

export const normalizeCustomerStatus = (status: unknown): CustomerStatus | undefined => {
  switch (status) {
    case 'INTERESSENT':
    case 'Prospect':
      return 'Prospect';
    case 'KUNDE':
    case 'Customer':
      return 'Customer';
    case 'ALTKUNDE':
    case 'Legacy':
      return 'Legacy';
    default:
      return undefined;
  }
};
